import { render, staticRenderFns } from "./proposal-by-opcr.vue?vue&type=template&id=b81b388a&scoped=true&"
import script from "./proposal-by-opcr.vue?vue&type=script&lang=js&"
export * from "./proposal-by-opcr.vue?vue&type=script&lang=js&"
import style0 from "./proposal-by-opcr.vue?vue&type=style&index=0&id=b81b388a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81b388a",
  null
  
)

export default component.exports